import React from 'react';
import './_sidebar.scss';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTachometerAlt, faFolder, faChartArea, faTable, faTrophy, faMedal,faColumns, faRoad, faAward, faQuestion, faDonate } from '@fortawesome/free-solid-svg-icons'
import { Link } from "gatsby";
library.add(faTachometerAlt, faFolder, faChartArea, faTable, faTrophy, faMedal, faColumns, faRoad, faAward, faQuestion, faDonate)


const Sidebar = (props) =>
  (<ul className={"sidebar navbar-nav "+(props.toggled ? 'untoggled' : 'toggled')}>
        <li className="nav-item ">
            <Link to="/" className="nav-link" activeClassName="active">
                <FontAwesomeIcon icon="tachometer-alt" />
                <span>Overview</span>
            </Link>
        </li>
        
        <li className="nav-item">
            <Link to="/headtohead/" className="nav-link" activeClassName="active" >
                <FontAwesomeIcon icon="columns"/>
                <span>Head to Head</span>
            </Link>
        </li>
        <li className="nav-item">
            <Link to="/standings/" className="nav-link" activeClassName="active" >
	            <FontAwesomeIcon icon="table"/>
	            <span>Standings</span>
            </Link>
	    </li>
        <li className="nav-item">
            <Link to="/gamerecords/" className="nav-link" activeClassName="active" >
                <FontAwesomeIcon icon="award"/>
                <span>Game Records</span>
            </Link>
        </li>
        <li className="nav-item">
            <Link to="/seasonrecords/" className="nav-link" activeClassName="active" >
                <FontAwesomeIcon icon="medal"/>
                <span>Season Records</span>
            </Link>
        </li>
        <li className="nav-item">
            <Link to="/roadmap/" className="nav-link" activeClassName="active">
                <FontAwesomeIcon icon="road" />
                <span>Roadmap</span>
            </Link>
        </li>
        {!props.paid && 
            <li className="nav-item">
                <Link to="/support/" className="nav-link" activeClassName="active">
                    <FontAwesomeIcon icon="donate" />
                    <span>Donate</span>
                </Link>
            </li>
        }
        <li className="nav-item">
            <a href="https://squidsource.atlassian.net/servicedesk/customer/portal/5" target="_blank" rel="noopener noreferrer" className="nav-link" >
                <FontAwesomeIcon icon="question" />
                <span>Help</span>
            </a>
        </li>
      </ul>);

export default Sidebar;
